<template>
<div class="p-2 bg-vc-blue-100 rounded-lg inline-flex flex-col gap-2"  v-if="allAnswers.length > 0">
  <relateds-list :relateds="allAnswers" />
</div>
</template>
<script>
import mixin from './_mixin_display'
import RelatedsList from './_related_list.vue'
export default {
  components: {RelatedsList},
  mixins: [mixin],
  skipBasic: true,
}
</script>